import { observer } from "mobx-react";
import { h } from "preact";
function FormErrors(props) {
    const { errors, fieldId } = props;
    if (errors.length == 0) {
        return null;
    }
    return (h("div", { class: "alert alert-danger", "data-field-id": fieldId },
        h("ul", { class: "list-unstyled" }, errors.map((error) => (h("li", null, error))))));
}
export default observer(FormErrors);
